import { useLocation } from 'router-v6'

/**
 * Hook to check if the current route is an API console route
 * @returns true if the current pathname starts with '/api'
 */
export const useIsApiConsole = (): boolean => {
  const location = useLocation()
  const isApiConsole = location.pathname.startsWith('/api')
  return isApiConsole
}

/**
 * Hook to get a path prefixed with '/api' if currently in API console context
 * @param path - The path to prefix (e.g., '/billing')
 * @returns The prefixed path if in API console, otherwise the original path
 * @example
 * usePrefixedPath('/billing') // Returns '/api/billing' if in API console
 * usePrefixedPath('/billing') // Returns '/billing' if not in API console
 */
export const usePrefixedPath = (path: string): string => {
  const isApiConsole = useIsApiConsole()

  if (!isApiConsole) {
    return path
  }

  // If path already starts with '/api', return as is
  if (path.startsWith('/api')) {
    return path
  }

  // Prefix with '/api'
  return `/api${path}`
}
